import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import RemoveIcon from "@mui/icons-material/Remove";
import PlusIcon from "@/components/common/icons/plus-icon";

interface SeeMoreCardProps {
  expanded: boolean;
  onClick: () => void;
  cardStyles: { height: number; borderRadius: string };
}

const SeeMoreCard: React.FC<SeeMoreCardProps> = ({ expanded, onClick, cardStyles }) => {
  const t = useTranslations("DESTINATIONS");
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        height: cardStyles.height,
        padding: "20px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        flex: {
          xs: "1 0 100%", // Mobile: full width
          sm: "1 0 calc(50% - 8px)", // Small tablet: 2 columns
          md: "1 0 calc(33.333% - 10.67px)", // Large tablet: 3 columns
          lg: "1 0 0" // Desktop: flexible width
        },
        borderRadius: cardStyles.borderRadius,
        backgroundColor: "background.cool_strong",
        cursor: "pointer",
        transition: "background 0.3s ease",
        "&:hover": {
          backgroundColor: "background.cool"
        }
      }}
      data-testid="see-more-card"
    >
      <Typography
        variant="h5"
        component="p"
        sx={{
          color: "primary.main",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          gap: 1
        }}
      >
        {expanded ? t("See Less") : t("See More")}
        {expanded ? <RemoveIcon /> : <PlusIcon />}
      </Typography>
    </Box>
  );
};

export default SeeMoreCard;
